var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryKg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_7902)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_7902",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_7902)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#F22A46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0001 13.3333C15.841 13.3333 17.3334 11.8409 17.3334 9.99996C17.3334 8.15901 15.841 6.66663 14.0001 6.66663C12.1591 6.66663 10.6667 8.15901 10.6667 9.99996C10.6667 11.8409 12.1591 13.3333 14.0001 13.3333Z",
    fill: "#FFF04D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3683 17.1495L14.0001 14.7137L15.6319 17.1495L16.0452 14.2469L18.5723 15.7335L17.6853 12.9389L20.6072 13.1819L18.5955 11.0489L21.3334 10.0001L18.5955 8.95118L20.6072 6.81824L17.6853 7.06117L18.5723 4.26663L16.0452 5.75324L15.6319 2.85059L14.0001 5.28644L12.3683 2.85059L11.9549 5.75324L9.42782 4.26663L10.3148 7.06117L7.39298 6.81824L9.40465 8.95118L6.66675 10.0001L9.40465 11.0489L7.39298 13.1819L10.3148 12.9389L9.42782 15.7335L11.9549 14.2469L12.3683 17.1495ZM18.6667 10.0001C18.6667 12.5774 16.5774 14.6667 14.0001 14.6667C11.4228 14.6667 9.33341 12.5774 9.33341 10.0001C9.33341 7.42273 11.4228 5.33339 14.0001 5.33339C16.5774 5.33339 18.6667 7.42273 18.6667 10.0001Z",
    fill: "#FFF04D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_7902"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryKg);
export default __webpack_public_path__ + "static/media/Country=KG.b9e28709bc2dbcf67b1d78a2841a218b.svg";
export { ForwardRef as ReactComponent };